import { ColDef } from '@ag-grid-enterprise/all-modules'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'
import { AgGridColumnType, AgGridExportType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'

export const laboratoryGridSubportionsColumnDefs: (ColDef | ExportedColDef | ExportedColGroupDef)[] = [
    { type: AgGridColumnType.CUSTOM_CHECKBOX },
    {
        headerName: i18n.tc('laboratory.grid.columns.caseNumber'),
        field: 'portion.sample.caseStudy.casCasenumber',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        hide: true,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.sampleNumber'),
        field: 'portion.sample.samLabel',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        hide: true,
        width: 120
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.portionNumber'),
        field: 'portion.porLabel',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        hide: true,
        width: 135
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.subportionNumber'),
        field: 'supLabel',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 145
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.assay'),
        field: 'assay.name',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.requester'),
        colId: 'requester.normalizedFullName',
        field: 'requester.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.location'),
        field: 'portion.sample.topographicCode.description',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.sampleType'),
        field: 'portion.sample.sampleType.description',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.pathologist'),
        colId: 'portion.sample.caseStudy.pathologist.normalizedFullName',
        field: 'portion.sample.caseStudy.pathologist.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.cutDate'),
        field: 'supCutDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.cutTechnician'),
        colId: 'cutter.normalizedFullName',
        field: 'cutter.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.stainingEntryDate'),
        field: 'supAssayStartDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        width: 110
    },
    // TODO: Front development required for next column
    /* {
        headerName: i18n.tc('laboratory.grid.lastSubportionCutDate') + ' (' + i18n.tc('global.block', 1) + ')',
        field: 'lastSubportionCutDate',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110
    }, */
    {
        headerName: i18n.tc('laboratory.grid.stainingDepartureDate'),
        field: 'supAssayEndDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.stainingEntryTechnician'),
        colId: 'assayStartResponsible.normalizedFullName',
        field: 'assayStartResponsible.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.stainingDepartureTechnician'),
        colId: 'assayEndResponsible.normalizedFullName',
        field: 'assayEndResponsible.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.status'),
        field: 'assayStatus',
        type: AgGridColumnType.COMMON_ASSAY_STATUS,
        exportField: 'assayStatus.name',
        exportType: AgGridExportType.TEXT,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.requestDate'),
        field: 'supRequestDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.deliverDate'),
        field: 'supDeliverDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.cuttingDevice'),
        colId: 'cuttingDevice.code',
        field: 'cuttingDevice.device',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.assayDevice'),
        colId: 'assayDevice.code',
        field: 'assayDevice.device',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.assemblyDevice'),
        colId: 'assemblyDevice.code',
        field: 'assemblyDevice.device',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.assemblyStartDate'),
        field: 'assemblyStartDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.assemblyEndDate'),
        field: 'assemblyEndDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.scannerDevice'),
        colId: 'scannerDevice.code',
        field: 'scannerDevice.device',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.scanStartDate'),
        field: 'scanStartDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.scanEndDate'),
        field: 'scanEndDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME
    },
    {
        headerName: i18n.tc('grid.detail.priority'),
        colId: 'priority.level',
        field: 'priority',
        type: AgGridColumnType.PRIORITY,
        exportField: 'priority.name',
        exportType: AgGridExportType.TEXT
    },
    // TODO Front: column for external control, pending development
    /* {
        headerName: i18n.tc('global.externalControl'),
        type: AgGridColumnType.TEXT
    }, */
    {
        headerName: i18n.tc('grid.hasAlarms'),
        headerTooltip: i18n.tc('grid.hasAlarms'),
        field: 'incidentsCount',
        type: AgGridColumnType.INCIDENT,
        exportType: AgGridExportType.INTEGER,
        filter: false,
        width: 55,
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-exclamation-triangle')
        }
    },
    {
        headerName: i18n.tc('grid.attachments'),
        headerTooltip: i18n.tc('grid.attachments'),
        field: 'attachmentsCount',
        type: AgGridColumnType.ATTACHMENT_COUNT,
        exportType: AgGridExportType.INTEGER,
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-paperclip')
        }
    },
    {
        headerName: i18n.tc('registry.btn.consultation'),
        headerTooltip: i18n.tc('registry.btn.consultation'),
        field: 'portion.sample.caseStudy.caseOfReference',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.BOOLEAN,
        filter: false,
        hide: false,
        width: 55,
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-glasses')
        },
        cellRenderer: ({ value }: ICellRendererParams) => value === true ? '<i class="success far fa-check"/>' : ''
    }
]
